<template>
  <div class="vch-newsletter-form">
    <h1 class="vch-newsletter-form__title heading-xl uppercase mb-xl">
      {{ currentTitle }}
    </h1>
    <h3 class="vch-newsletter-form__title heading-md uppercase mb-md">
      {{ formDescription }}
    </h3>
    <template>
      <div class="vch-grid">
        <div
          class="
            vch-col-12
            vch-col-md-10
            vch-col-offset-md-1
            vch-col-lg-8
            vch-col-offset-lg-2
            vch-col-xl-6
            vch-col-offset-xl-3
          "
        >
          <p class="vch-newsletter-form__instructions">
            {{ formMandatoryInstruction }}
          </p>
          <slot name="form">Form Here</slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { parseSitecoreForm, bindFormField } from 'Utils/form';
import { pushEvent } from 'Utils/datalayer';
import { mixinFormRecaptcha } from 'Mixins/formRecaptcha/formRecaptcha';

export default {
  name: 'vch-newsletter-form',
  mixins: [mixinFormRecaptcha],
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    formDescription: {
      type: String,
      required: false,
    },
    formMandatoryInstruction: {
      type: String,
    },
    defaultErrorMessage: {
      type: String,
      required: false,
      default: 'An error occured while processing your request.',
    },
    taggingOrigin: {
      type: String,
      required: false,
      default: 'newsletter form',
    },
    testHost: {
      type: String,
      required: false,
    },
    errorMessageFormIncomplete: {
      type: String,
      required: true,
    },
    redirectPageUrl: {
      type: String,
     default: '',
    }
  },
  data() {
    return {
      currentTitle: this.formTitle,
      formSuccess: false,
      errorExistsEmailConfirm: false,
      errorExistsEmailType: false,
      errorExistsDob: false,
      useEmailFlow: false,
      fields: [],
      formProperties: null,
      parser: new DOMParser(),
      errorWrapperNode: null,
      initialLoad: true,
      genderValue: null,
    };
  },
  computed: {
    formActionUrl() {
      return process.env.NODE_ENV === 'production'
        ? this.formProperties.formAction
        : `${this.testHost}${this.formProperties.formAction}`;
    },
  },
  created() {
    setTimeout(() => {
      this.fieldDataPresent();
      this.confirmEmailOnBlur();
      this.validateEmailOnBlur();
      this.validateAgeOnBlur();
    }, 1000);
  },
  mounted() {
    // To add custome styled toggle button
    this.togglerCreator();

    //To animate the label on input
    this.formInputLabelAnim();
    const formNode = this.$slots.form[0].children[0].children[0];
    if (!formNode?.elm) {
      return;
    }

    // Collect the base form properties and hijack form submit
    this.formProperties = parseSitecoreForm(formNode?.elm);
    formNode.elm.addEventListener('submit', this.onSubmit);

    // Create the error message wrapper
    this.errorWrapperNode = document.createElement('div');
    this.errorWrapperNode.setAttribute('role', 'status');
    this.errorWrapperNode.classList.add('vch-newsletter-form__errorSummary');
    const submitButton = formNode?.elm.querySelector('input[type="submit"]');
    submitButton.parentNode.insertBefore(this.errorWrapperNode, submitButton);

    // Traverse the form and collect all the inputs into a single list
    formNode.children
      .filter((node) => node.tag === 'div' || node.tag === 'input')
      .forEach((node) => {
        const foundFieldInfo = bindFormField(node);
        if (foundFieldInfo.nestedFieldInfo.length) {
          this.fields.push(...foundFieldInfo.nestedFieldInfo);
        }
        this.fields.push(foundFieldInfo);
      });
    this.checkGender()
  },
  methods: {
    checkGender(){
      var isGenderMandatory = document.getElementsByClassName('gender_container');
      if (isGenderMandatory.length > 0){
        let genderError= document.querySelector('.salutation_container.gender_container').getElementsByClassName('toggler-item-label')[0].firstChild.getAttribute("data-val-required");
        let genderSection = document.querySelector('.salutation_container.gender_container');
        document.querySelector('.salutation_container.gender_container').lastChild.innerText = genderError;
        if (genderSection) {
          let errorsection = genderSection.getElementsByClassName('field-validation-valid')[0]
          genderSection.addEventListener('change', (e) => {
            if (e.target && e.target.defaultValue) {
              this.genderValue = e.target.defaultValue;
              if (errorsection) {
                errorsection.style.display = 'none';
              }
            }
        })
          if (this.initialLoad) {
            errorsection.style.display = 'none';
            this.initialLoad = false;
          } else if (!this.genderValue) {
          errorsection.style.display = 'block';
         }
        }
      } else {
        let genderOptional = document.querySelector('.salutation_container');
        if (genderOptional) {
          genderOptional.addEventListener('change', (e) => {
            if (e.target && e.target.defaultValue) {
              this.genderValue = e.target.defaultValue;
            }
          });
        }
      }
    },
    async onSubmit(e) {
    e.preventDefault();
      e.submitter.classList.add('button-disable');
      let dobField = document.querySelector('.dob-sections input[type="date"]');
      let confemail = document.querySelector(
        '.confirm-email-sections .input_field_default'
      );
      if (confemail) {
        this.confirmEmailCheck();
      }
      this.validateEmail();
      if (dobField) {
        this.ageValidation(dobField.value);
      }
      this.checkGender();
        if (
        !this.validateFields() ||
        this.errorExistsEmailType ||
        this.errorExistsDob ||
        this.errorExistsEmailConfirm
      ) {
        e.preventDefault();
        // eslint-disable-next-line sonarjs/no-redundant-jump
        return;
      } else {
        // Recaptcha Flow via Mixin
        this.peformRecaptcha()
          .then(async (canSubmit) => {
            if (canSubmit) {
              this.pushSubmitTags();
              await fetch(this.formActionUrl, {
                method: 'POST',
                mode: process.env.NODE_ENV === 'production' ? 'cors' : 'no-cors',
                body: this.assembleFormData(),
              })
              .then((response) => {
                  if (response.status == 200) {
                    const dataLayer = window.dataLayer || [];
                    dataLayer.forEach((item, index) => {
                    if (item.brand !== undefined) {
                      dataLayer[index].uiEmailId = response.headers.get('encryptedEmailId'); 
                    }
                    });
                  }
                  if (response.status >= 400 && response.status < 600) {
                    throw new Error(this.defaultErrorMessage);
                  }
                  return response;
              })
              .then((response) => {
                const htmlResponse = this.parser.parseFromString(
                  response,
                  'text/xml'
                );
                const errorWrapper = htmlResponse.querySelector(
                  '.validation-summary-errors'
                );
                if (errorWrapper) {
                  const serverErrorMsgs = errorWrapper.querySelectorAll('li');
                  const summaryErrors = serverErrorMsgs.map(
                    (msg) => msg.textContent
                  );
                  this.setErrorMessage(summaryErrors);
                } else {
                  this.formSuccess = true;
                  if(this.redirectPageUrl) {
                    window.location.href = this.redirectPageUrl;
                  }
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                  });
                }
              })
              .catch((error) => {
                this.setErrorMessage(error.message);
              });
            }
          })
          .catch(() => {
            this.setErrorMessage(this.defaultErrorMessage);
          });
        }
    },
    setErrorMessage(errorMessage) {
      this.errorWrapperNode.innerText = errorMessage;
    },
    validateFields() {
      const validationErrors = [];
      let hasTermsError = false;
      this.fields.forEach((field) => {
        const fieldErrors = field.validate();
        if (fieldErrors.length && field.isTermsAgree) {
          hasTermsError = true;
        }
        validationErrors.push(...fieldErrors);
      });

      if (hasTermsError) {
        this.setErrorMessage(this.errorMessageFormTerms);
        return false;
      } else if (validationErrors.length > 0) {
        document.querySelector('.button-disable')?.classList.remove('button-disable');
        this.setErrorMessage(this.errorMessageFormIncomplete);
        return false;
      }
      return true;
    },
    assembleFormData() {
      const formData = new FormData();
       this.fields.forEach((field) => {
        if (field.inputElement) {
          // Get gender field selected value
          const input = field.inputElement;
          const scFieldName = input.dataset.scFieldName;
          if (scFieldName === 'gender') {
            formData.append(field.inputElement.name, this.genderValue);
          } else {
            formData.append(field.inputElement.name, field.inputElement.value);
          }
        }
        field.hiddenFields.forEach((hiddenField) => {
          if (hiddenField.name) {
            formData.append(hiddenField.name, hiddenField.value);
          }
        });
      });
      return formData;
    },
    togglerCreator() {
      let togglerItem = document.createElement('div');
      togglerItem.className = 'toggler-item';
      let togglerDivs = document.querySelectorAll('.salutation_container');
      togglerDivs.forEach((togglerDivs) => {
        let togglerOuter = togglerDivs.getElementsByTagName('label');
        for (let i = 1; i < togglerOuter.length; i++) {
          togglerOuter[i].appendChild(togglerItem.cloneNode(true));
          togglerOuter[i].classList.add('toggler-item-label');
        }
      });

      let togglerOuterConsent = document
        .querySelector('.consent_container')
        .getElementsByTagName('label');
      for (let i = 0; i < togglerOuterConsent.length; i++) {
        togglerOuterConsent[i].appendChild(togglerItem.cloneNode(true));
        togglerOuterConsent[i].classList.add('toggler-item-label');
      }
    },
    formInputLabelAnim() {
      let formInputField = document.querySelectorAll('.input_field_default');
      for (var i = 0, len = formInputField.length; i < len; i++) {
        let labelItem = formInputField[i].previousElementSibling;
        formInputField[i].addEventListener('focus', () => {
          this.formInputLabelFocus(labelItem);
        });
        formInputField[i].addEventListener('blur', (e) => {
          if (e.currentTarget.value === '' || e.currentTarget.value === null) {
            this.formInputLabelBlur(labelItem);
          }
        });
      }
    },
    formInputLabelFocus(elem) {
      elem.classList.add('input_label_default--focused');
    },
    formInputLabelBlur(elem) {
      elem.classList.remove('input_label_default--focused');
    },
    confirmEmailOnBlur() {
      let confemail = document.querySelector(
        '.confirm-email-sections .input_field_default'
      );
      if (confemail) {
        confemail.addEventListener('blur', () => {
          this.confirmEmailCheck();
        });
      }
    },
    validateEmailOnBlur() {
      let emailField = document.querySelector(
        '.email-sections .input_field_default'
      );
      if (emailField) {
        emailField.addEventListener('blur', () => {
          this.validateEmail();
        });
      }
    },
    validateAgeOnBlur() {
      let dobField = document.querySelector('.dob-sections input[type="date"]');
      if (dobField) {
        dobField.addEventListener('blur', () => {
          this.ageValidation(dobField.value);
        });
      }
    },
    confirmEmailCheck() {
      let email = document.querySelector(
        '.email-sections .input_field_default'
      ).value;
      let confemail = document.querySelector(
        '.confirm-email-sections .input_field_default'
      ).value;
      if(confemail==''){
        document.querySelector('.email-confirm-error').style.display = 'block';
        this.errorExistsEmailConfirm = true;
      }else{
        if (email != confemail) {
        document.querySelector('.email-confirm-error').style.display = 'block';
        this.errorExistsEmailConfirm = true;
      } else {
        document.querySelector('.email-confirm-error').style.display = 'none';
        this.errorExistsEmailConfirm = false;
      }
      }
    },
    validateEmail() {
      let email = document.querySelector(
        '.email-sections .input_field_default'
      );

      if(email == '' || email == null){
        document.querySelector('.email-type-error').style.display = 'block';
        this.errorExistsEmailType = true;
      }else if(!email.value.match(email.dataset.valRegexPattern)){
          document.querySelector('.email-type-error').style.display = 'block';
          this.errorExistsEmailType = true;
      }else{
        document.querySelector('.email-type-error').style.display = 'none';
        this.errorExistsEmailType = false;
      } 
    },
    ageValidation(val) {
      if(!val){
        document.querySelector('.dob-validation-error').style.display = 'none';
        this.errorExistsDob = false;
      }else {
        const maxLimitDOB = new Date();
        const inputDate = new Date(val);
        maxLimitDOB.setFullYear(maxLimitDOB.getFullYear() - 18);
        if (maxLimitDOB.getTime() < inputDate.getTime()) {
          document.querySelector('.dob-validation-error').style.display = 'block';
          this.errorExistsDob = true;
        } else {
          document.querySelector('.dob-validation-error').style.display = 'none';
          this.errorExistsDob = false;
        }
      }
    },
    fieldDataPresent() {
      let formInputField = document.querySelectorAll('.input_field_default');
      for (var i = 0, len = formInputField.length; i < len; i++) {
        if (formInputField[i].value !== '') {
          let labelItem = formInputField[i].previousElementSibling;
          labelItem.classList.add('input_label_default--focused');
        }
      }
    },
    pushSubmitTags() {
      pushEvent({
        event: 'uaevent',
        event_name: 'newsletter_registration',
        ecommerce: 'undefined',
        eventCategory: 'registration',
        eventAction: 'newsletter',
        eventLabel: 'footer',
        referral: 'footer',
      });
    },
  },
};
</script>

<style lang="scss" src="./newsletter-form.scss"></style>